<template>
  <div class="section">
    <section>
      <h1 class="pagetitle">ゴールド購入</h1>
      <p class="mb-5 has-text-centered">ゴールド大増量セール中！ <br class="is-hidden-tablet">※2025年5月31日まで</p>
      <b-field
        v-for="(option, index) in doronOptions"
        :key="index"
        position="is-centered"
      >
        <b-radio v-model="optionIndex" :native-value="index">
          <div class="doron-info-container">
            <div class="doron-icon-container">
              <img src="@/assets/image/doron/doron.svg" alt="" />
            </div>
            <div class="doron-amount-container">{{ option.amount }}</div>
            <div>+</div>
            <div class="doron-icon-container">
              <img src="@/assets/image/doron/doronFree.svg" alt="" />
            </div>
            <div class="doron-amount-container">
              {{ option.freeAmount }}
            </div>
          </div>
        </b-radio>
      </b-field>
      <div class="has-text-centered mt-5">
        <div class="button" @click="onClickPurchase">
          購入手続きをする
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DoronPurchaseFormModal from '@/components/DoronPurchaseFormModal';
import * as modal from '@/utils/modal';
import {DORON_TO_YEN_RATE} from '@/consts/global';

export default {
  name: 'DoronPurchaseForm',
  computed: {
    doron: function () {
      return this.$store.getters['doron/doronAmount'];
    }
  },
  props: {
    parent: { type: Object },
  },
  data() {
    return {
      doronOptions: [
        {
          amount: 100,
          freeAmount: 10
        },
        {
          amount: 500,
          freeAmount: 50
        },
        {
          amount: 1000,
          freeAmount: 100
        },
        {
          amount: 3000,
          freeAmount: 500
        },
        {
          amount: 5000,
          freeAmount: 1500
        },
        {
          amount: 10000,
          freeAmount: 5000
        }
      ],
      optionIndex: 0,
      doronToYenRate: DORON_TO_YEN_RATE
    };
  },
  methods: {
    onClickPurchase() {
      const amount = this.doronOptions[this.optionIndex].amount;
      const freeAmount = this.doronOptions[this.optionIndex].freeAmount;
      const parent = this.parent ? this.parent : this;
      this.$buefy.modal.open({
        parent: parent,
        component: DoronPurchaseFormModal,
        hasModalCard: true,
        trapFocus: true,
        canCancel: false,
        props: {
          doronAmount: amount,
          freeDoronAmount: freeAmount,
          doronToYenRate: this.doronToYenRate
        },
        events: {
          success: () => {
            modal.alert(parent, "ゴールド購入", "購入が完了しました。", null, () => {this.$emit('purchased');});
          },
          failure: () => {
            modal.alert(parent, "エラー", "決済に失敗しました。", null, null);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  color: $black;
}
.field {
  width: fit-content;
  margin: auto;
}
.doron-info-container {
  margin: 4px 0;
  height: 20px;
  display: flex;
  .doron-icon-container {
    width: 20px;
    height: 20px;
    margin: 0 8px;
  }
  .doron-amount-container {
    width: 60px;
  }
}
</style>
